module.exports = __webpack_public_path__ + "images/file_icons_v2/numbers-eb4d073d27c42296b9c737f8336f2a51.svg";